import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./css/FooterInsideSmallerPages.css";


const FooterInsideSmallerPages = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    
    const handleBuyNowClick = async () => {
        user? navigate("/webshop") : navigate("/login", {state: {from: {pathname:"/webshop"}}})
    };
    
    const handleTillProdukter = () => {
        sessionStorage.removeItem("lastScrolled");
        sessionStorage.setItem("productionOnly", "true");

        navigate("/");
    };

    return (
        <div className="stick-to-the-bottom">
            <div className="btn-container">
                <button className="sticky-buy-btn-footer" onClick={handleBuyNowClick}>
                    TILL SHOPPEN <br />
                    KÖP NU
                </button>
                <button className="sticky-share-btn-footer" onClick={handleTillProdukter}>
                    TILL PRODUKTEN <br /> MER INFO
                </button>
            </div>
        </div>
    )
};

export default FooterInsideSmallerPages;